// OvernightDay1Cap — the cook-mode replacement for the bottom action
// row when the user reaches an overnight step. Stamps the rest as
// "done for tonight," minimizes the cook (session row stays alive),
// and lets the morning push + banner pull them back in for Day 2.
//
// Shape: a single muted card + primary button. The user just spent
// 90 minutes on stretch-and-folds; the screen should feel like a
// closing chord, not a continuation.

import { FONT, COLOR } from "../lib/tokens";

export default function OvernightDay1Cap({ stepTitle, onCapDay1 }) {
  return (
    <div style={{
      marginTop: 24,
      padding: "16px 18px",
      background: "rgba(122,91,161,0.08)",
      border: "1px solid rgba(122,91,161,0.42)",
      borderRadius: 12,
      display: "flex",
      flexDirection: "column",
      gap: 10,
    }}>
      <div style={{
        fontFamily: FONT.mono, fontSize: 10, fontWeight: 700,
        color: "#7A5BA1", letterSpacing: "0.14em",
      }}>
        OVERNIGHT REST · DAY 1 OF 2
      </div>
      <div style={{
        fontFamily: FONT.serif, fontStyle: "italic", fontWeight: 500,
        fontSize: 18, color: COLOR.ink, lineHeight: 1.3,
      }}>
        {stepTitle || "Cold ferment overnight"}
      </div>
      <div style={{
        fontFamily: FONT.forma, fontSize: 13, fontWeight: 400,
        color: COLOR.muted, lineHeight: 1.45,
      }}>
        Tuck the dough in and step out — your phone will wake you up when
        it's time to bake. The cook stays open in the background.
      </div>
      <button
        onClick={onCapDay1}
        style={{
          marginTop: 4,
          padding: "14px",
          background: "#7A5BA1",
          color: "#FFF8EC",
          border: "none",
          borderRadius: 12,
          fontFamily: FONT.mono,
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: "0.08em",
          cursor: "pointer",
        }}
      >
        🌙 GOOD NIGHT — SEE YOU TOMORROW ›
      </button>
    </div>
  );
}
